import type { FormStep } from "./form-types";
import type {
  LeadFormStepStyles,
  LeadFormStyleClasses,
} from "./lead-form-styles";

import { useMemo } from "react";
import { getLeadFormStepStyles } from "./lead-form-styles";

export type { LeadFormStepStyles } from "./lead-form-styles";

/**
 * Returns step-derived style class names for the lead form, memoized by inputs.
 */
export function useStepStyles(
  styleClasses: LeadFormStyleClasses,
  currentStep: FormStep,
  steps: FormStep[],
  isHeroMode: boolean,
): LeadFormStepStyles {
  return useMemo(
    () => getLeadFormStepStyles(styleClasses, currentStep, steps, isHeroMode),
    [styleClasses, currentStep, steps, isHeroMode],
  );
}
